import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69857e00921dc90014db969b/pty_tropics/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69857e00921dc90014db969b/pty_tropics/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69857e00921dc90014db969b/pty_tropics/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69857e00921dc90014db969b/pty_tropics/src/components/ui/AppImage.tsx");
